exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Root___1QJSV {\n  display: inline-flex;\n  align-items: center;\n}\n\n.Root___1QJSV *:not(:first-child) {\n  margin-left: 0.25rem;\n}\n\n.ExtraLabel___1iRgy {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-small);\n  color: var(--color-component-badge-count);\n}\n", ""]);

// exports
exports.locals = {
	"Root": "Root___1QJSV",
	"ExtraLabel": "ExtraLabel___1iRgy"
};